// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82ffd28c","239":"5ac5d200","667":"016d9624"}[chunkId] + ".chunk.js";
};